import { render, staticRenderFns } from "./RelatedResourceMessagePrompt.vue?vue&type=template&id=47f47ddc"
import script from "./RelatedResourceMessagePrompt.vue?vue&type=script&lang=js"
export * from "./RelatedResourceMessagePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports